import localforage from 'localforage'

localforage.config({
  driver:localforage.LOCALSTORAGE,
  storeName:'tuition'
})

export default localforage;